module.exports = __webpack_public_path__ + "img/quiz_05.99856e87.jpg";